import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import { useTheme } from '@mui/material';
import React, {
  FC, useState, memo,
} from 'react';
import { TCustomTheme } from '@mgm/common/theme';
import { useCustomTheme } from '@mgm/common/hooks/useCustomTheme';
import { TextMaxLine } from '@mgm/common/components';
import { Label, LabelColor } from '@mgm/common/components/base';
import { useAppSelector } from '../../../hooks/useAppStore';
import { getTokenDetails } from '../../../store/authenticate/selectors';

type TFilterTabs = {
  tabs: Array<{
    value: string | number,
    label: string,
    color: string,
    count?: number
  }>
  onFilterChange: (newValue: number) => void
  initialFilter?: number | string
  isDisplayBackground?: boolean
};

export const FilterTabs: FC<TFilterTabs> = ({
  tabs, onFilterChange, initialFilter, isDisplayBackground = true,
}) => {
  const tokenDetails = useAppSelector(getTokenDetails);
  const theme = useTheme() as TCustomTheme;
  const { isMobile } = useCustomTheme(theme);
  const [filterStatus, setFilterStatus] = useState(initialFilter || 0);

  const handleFilterStatus = (_event: React.SyntheticEvent<Element, Event>, newValue: number) => {
    setFilterStatus(newValue);
    onFilterChange(newValue);
  };

  return (
    <Tabs
      value={filterStatus}
      onChange={handleFilterStatus}
      variant="scrollable"
      scrollButtons="auto"
      {...isMobile && {
        allowScrollButtonsMobile: true,
      }}
      sx={{
        px: 2,
        ...(isDisplayBackground && {
          bgcolor: tokenDetails.settings.ui?.theme === 'light' ? 'background.neutral' : '#161C24',
        }),
      }}
    >
      {tabs.map((tab) => (
        <Tab
          key={tab.value}
          value={tab.value}
          label={(
            <TextMaxLine variant="subtitle2" line={1}>
              {tab.label}
            </TextMaxLine>
)}
          iconPosition="start"
          {...(tab.count && {
            icon: (
              <Label color={tab.color as LabelColor} sx={{ mr: 1 }}>
                {tab.count}
              </Label>
            ),
          })}
        />
      ))}
    </Tabs>
  );
};

export const MemoizedFilterTabs = memo(FilterTabs);
